export default __webpack_public_path__ + "static/media/no_data_available_list&card.e3651d3d.svg";